module.exports = __webpack_public_path__ + "static/noise-fd78ec6290bf530353d21112cdc32fd1.png";